// © Microsoft Corporation. All rights reserved.

import { AccentButton } from "@microsoft/fast-components-react-msft";
import { avatarFallback, enums, placeholderImages } from "@msnews/social-utils";
import React from "react";
import { SocialProps } from "../Social.props";

export default class OnboardingUnderagePage extends React.Component<SocialProps> {
    containerRef: React.RefObject<HTMLDivElement>;

    constructor(props) {
        super(props);
        this.containerRef = React.createRef<HTMLDivElement>();
    }

    closePopup() {
        this.props.popupConnector.closePopup();
    }

    render() {
        const { managedClasses, me, t } = this.props;

        const { primaryAvatar, avatarStatus } = me;

        return (
            <div className={managedClasses.onboardingUnderagePageContainer} ref={this.containerRef}>
                <img
                    alt={t.AriaLabelsProfilePicture}
                    className={`cwt-avatar ${avatarStatus == enums.userAvatarStatusType.notAllow ? "cwt-error":""}`}
                    src={primaryAvatar || placeholderImages.avatar}
                    onError={(e)=>{ avatarFallback(e); }}
                />

                <h2 className="cwt-title"> {t.OnboardingUnderageTitle} </h2>
                <p className="cwt-sub-title"> {t.OnboardingUnderageMsg}  </p>

                <div className="cwt-buttons">
                    <AccentButton className="cwt-fast-button" onClick={this.closePopup.bind(this)}> {t.OnboardingCloseWindow} </AccentButton>
                </div>
            </div>
        );
    }
}
